module.exports = __webpack_public_path__ + "img/icon-over-catalogo-libros.4b7e08fe.svg";